/**
 * 设置页面路由
 */
export default [
  {
    path: '/dashboard/game/:gamecode/datalab/chart/explore', // 经分承接页的下钻页 图表探索页面 (不展示左侧菜单)
    component: '@/pages/datalab/pages/Multidimensional/Analysis/index',
  },
  {
    path: '/dashboard/game/:gamecode/authEmbed', // 通用鉴权 iframe 全屏页面（gettoken 鉴权，不展示菜单）
    component: '@/pages/dashboard/pages/authEmbed',
  },
  {
    path: '/dashboard',
    component: '@/pages/dashboard/layouts/index',
    routes: [
      {
        path: './:type/:gamecode',
        routes: [
          {
            path: './forecast',
            component: '@/pages/dashboard/pages/forecast',
          },
          {
            path: './looker/demo',
            component: '@/pages/dashboard/pages/looker',
          },
          {
            path: './looker/Login-Funnel',
            component: '@/pages/dashboard/pages/looker',
          },
          {
            path: './looker/explore',
            component: '@/pages/dashboard/pages/looker',
          },
          {
            path: './looker/report/:reportId',
            component: '@/pages/dashboard/pages/looker',
          },
          {
            path: './powerbi/demo',
            component: '@/pages/dashboard/pages/powerbi',
          },
          {
            path: './powerbi/simple',
            component: '@/pages/dashboard/pages/powerbi/simple',
          },
          {
            path: './authPath/report/:reportId',
            component: '@/pages/dashboard/pages/auth',
          },
          {
            path: './web/report/:reportId',
            component: '@/pages/dashboard/pages/web',
          },
          {
            path: './tableau/report/:reportId',
            component: '@/pages/dashboard/pages/tableau',
          },
          {
            path: './preset/report/:reportId',
            component: '@/pages/dashboard/pages/preset',
          },
          {
            path: './pdf/report/:reportId',
            component: '@/pages/dashboard/pages/pdf',
          },
          {
            path: './cos/report/:reportId',
            component: '@/pages/dashboard/pages/cos',
          },
          {
            path: './dashApp/report/:reportId',
            component: '@/pages/dashboard/pages/dashApp',
          },
          {
            path: './overview/daily/:tab?',
            component: '@/pages/dashboard/pages/overview/daily',
          },
          // 数据格式化自测页面，需要自测的时候放开
          // {
          //   path: './dataTest/test',
          //   component: '@/pages/dashboard/pages/dataTest/index',
          // },
          {
            // 测试Card组件
            path: './dataTest/card',
            component: '@/pages/dashboard/pages/dataTest/card',
          },
          {
            path: './sth/worldmap',
            component: '@/pages/dashboard/pages/sth/newWorldMap/index',
          },
          {
            path: './sth/oldWorldmap',
            component: '@/pages/dashboard/pages/sth/worldMap/index',
          },
          {
            path: './sth/matrix',
            component: '@/pages/dashboard/pages/sth/matrix/index',
          },
          {
            path: './overview/versionDaily',
            component: '@/pages/dashboard/pages/overview/versionDaily',
          },
          {
            path: './overview/xh-daily',
            component: '@/pages/dashboard/pages/overview/dailyXh',
          },
          {
            path: './overview/acc-daily',
            component: '@/pages/dashboard/pages/overview/dailyAcc',
          },
          {
            path: './overview/lifetime',
            component: '@/pages/dashboard/pages/overview/lifetime',
          },
          {
            path: './wow/index',
            component: '@/pages/dashboard/pages/wow/index',
          },
          {
            path: './changeAnalysis',
            component: '@/pages/dashboard/pages/changeAnalysis',
          },
          {
            path: './dauByRegion',
            component: '@/pages/dashboard/pages/dauByRegion',
          },
          {
            path: './benchmark/explore',
            component: '@/pages/dashboard/pages/benchmark/index',
          },
          {
            path: './report/abnormalReport',
            component: '@/pages/dashboard/pages/abnormalReport/index',
          },
          {
            path: './benchmark/gtdrAssessment',
            component: '@/pages/dashboard/pages/benchmark/gtdrAssessment',
          },

          {
            path: './overview/pcConsoleDailyV2/:tab?',
            component: '@/pages/dashboard/pages/overview/pcConsoleDailyV2',
          },
          {
            path: './overview/pcConsoleDailyV3/:tab?',
            component: '@/pages/dashboard/pages/overview/pcConsoleDailyV3',
          },
          {
            path: './overview/pcConsoleWeekly/:tab?',
            component: '@/pages/dashboard/pages/overview/pcConsoleWeekly',
          },
          {
            path: './overview/pcConsoleWeekV2/:tab?',
            component: '@/pages/dashboard/pages/overview/pcConsoleWeeklyV2',
          },
          {
            path: './overview/pcConsoleMonthly/:tab?',
            component: '@/pages/dashboard/pages/overview/pcConsoleMonthly',
          },
          {
            path: './overview/pcConsoleMonthV2/:tab?',
            component: '@/pages/dashboard/pages/overview/pcConsoleMonthlyV2',
          },
          {
            path: './overview/kpi',
            component: '@/pages/dashboard/pages/overview/kpiOverview',
          },
          // {
          //   path: './overview/eventsDetails',
          //   component: '@/pages/dashboard/pages/overview/EventsDetails',
          // },
          {
            path: './overview/weekly/:tab?',
            component: '@/pages/dashboard/pages/overview/weekly',
          },

          {
            path: './overview/monthly/:tab?',
            component: '@/pages/dashboard/pages/overview/monthly',
          },
          {
            path: './overview/xh-monthly',
            component: '@/pages/dashboard/pages/overview/monthXh',
          },
          {
            path: './overview/dataRange',
            component: '@/pages/dashboard/pages/overview/dataRange',
          },
          {
            path: './engagement/churn/index',
            component:
              '@/pages/dashboard/pages/engagement/churn/Nightingale/index',
          },
          {
            path: './comparison/DateComparison/index',
            component:
              '@/pages/dashboard/pages/comparison/dateComparison/index',
          },
          // 重构新加engagement路由 end

          {
            path: './realtime/users/:tab?',
            component: '@/pages/dashboard/pages/realtime/realtimeUsers/index',
          },
          {
            path: './realtime/new/revenue',
            component: '@/pages/dashboard/pages/realtime/revenuev2/index',
          },
          {
            path: './realtime/nightingaleUsers/:tab?',
            component:
              '@/pages/dashboard/pages/realtime/realtimeUsers/realtimeUsersNightingale/index',
          },
          {
            path: './engagement/register/:tab?',
            component: '@/pages/dashboard/pages/engagement/new/index',
          },
          {
            path: './realtime/revenue/:tab?',
            component: '@/pages/dashboard/pages/realtime/revenue/index',
          },
          {
            path: './realtime/steam',
            component: '@/pages/dashboard/pages/realtime/steam/index',
          },
          {
            path: './realtime/sales/:tab?',
            component: '@/pages/dashboard/pages/realtime/steamSales/index',
          },
          {
            path: './realtime/steamCCU/:tab?',
            component: '@/pages/dashboard/pages/realtime/steamCCU/index',
          },
          {
            path: './realtime/baseSales/:tab?',
            component: '@/pages/dashboard/pages/realtime/baseSales/index',
          },
          {
            path: './realtime/uaSpend/:tab?',
            component: '@/pages/dashboard/pages/realtime/uaSpend/index',
          },
          {
            path: './realtime/iaaRevenue/:tab?',
            component: '@/pages/dashboard/pages/realtime/iaaRevenue/index',
          },
          {
            path: './realtime/overview/:tab?',
            component: '@/pages/dashboard/pages/realtime/overview/index',
          },
          {
            path: './retention/index/:tab?',
            component: '@/pages/dashboard/pages/engagement/retention/index',
          },
          {
            path: './engagement/lt',
            component: '@/pages/dashboard/pages/engagement/lt/index',
          },
          {
            path: './retention/nightingale/:tab?',
            component:
              '@/pages/dashboard/pages/engagement/retention/Nightingale',
          },
          {
            path: './engagement/rollingRetention/:tab?',
            component:
              '@/pages/dashboard/pages/engagement/rollingRetention/index',
          },
          {
            path: './engagement/rateReturn/:tab?',
            component: '@/pages/dashboard/pages/engagement/returnV2/index',
          },
          {
            path: './engagement/return',
            component: '@/pages/dashboard/pages/engagement/return/index',
          },
          {
            path: './engagement/churn/:tab?',
            component: '@/pages/dashboard/pages/engagement/churn/index',
          },
          {
            path: './engagement/active/:tab?',
            component: '@/pages/dashboard/pages/engagement/active/index',
          },
          {
            path: './monetization/revenue/:tab?',
            component: '@/pages/dashboard/pages/monetization/revenue',
          },
          {
            path: './monetization/salesOverview/:tab?',
            component:
              '@/pages/dashboard/pages/monetization/SalesOverview/index',
          },
          {
            path: './monetization/salesBreakdown',
            component:
              '@/pages/dashboard/pages/monetization/SalesBreakdown/index',
          },
          {
            path: './monetization/inGameRevenue/:tab?',
            component: '@/pages/dashboard/pages/monetization/ingameRevenue',
          },
          {
            path: './monetization/inGameRevenueMerge/:tab?',
            component:
              '@/pages/dashboard/pages/monetization/ingameRevenue/merge',
          },
          {
            path: './monetization/ltv',
            component: '@/pages/dashboard/pages/monetization/ltv',
          },
          {
            path: './monetization/adFunnel',
            component: '@/pages/dashboard/pages/monetization/adFunnel',
          },
          {
            path: './comparisonAnalysis/dateComparison/:tab?',
            component:
              '@/pages/dashboard/pages/comparison/dateComparison/index',
          },
          {
            path: './comparisonAnalysis/eventComparison',
            component:
              '@/pages/dashboard/pages/comparison/eventComparison/index',
          },
          {
            path: './comparisonAnalysis/countryComparison',
            component:
              '@/pages/dashboard/pages/comparison/countryComparison/index',
          },
          {
            path: './ua/spend',
            component: '@/pages/dashboard/pages/ua/spend',
          },
          {
            path: './ua/noSpend',
            component: '@/pages/dashboard/pages/ua/noSpend',
          },
          {
            path: './competitor/index/:tab?',
            component: '@/pages/dashboard/pages/competitor/index',
          },
          {
            path: './competitor/xh-index/:tab?',
            component: '@/pages/dashboard/pages/competitor/index',
          },
          // 订阅
          {
            path: './subscribe/subscribeManage',
            component: '@/pages/dashboard/pages/subscribe/subscribeManage',
          },
          {
            path: './subscribe/subscribeRecord',
            component: '@/pages/dashboard/pages/subscribe/subscribeRecord',
          },
          {
            path: './subscribe/subscribeSetting',
            component: '@/pages/dashboard/pages/subscribe/subscribeSetting',
          },
          // 多时区
          {
            path: './multiTimezone/dailyTimezone/:timezonetype',
            component: '@/pages/dashboard/pages/multiTimezone/dailyByTimezone',
          },
          {
            path: './multiTimezone/newUsers/:timezonetype',
            component:
              '@/pages/dashboard/pages/multiTimezone/newUsersRetention',
          },
          {
            path: './eventAnalysis/eventDetails',
            component:
              '@/pages/dashboard/pages/eventAnalysis/EventDetails/index',
          },
          {
            path: './eventAnalysis/eventAnalysis',
            component: '@/pages/dashboard/pages/eventAnalysis/index',
          },
          {
            path: './eventAnalysis/eventExploration',
            component:
              '@/pages/dashboard/pages/eventAnalysis/EventExploration/index',
          },
          {
            path: './performance/overall/:tab?',
            component: '@/pages/dashboard/pages/performance',
          },
          // 新加漏斗页面
          {
            path: './funnel/registerFunnel',
            component: '@/pages/dashboard/pages/funnel/registerFunnel',
          },
          {
            path: './funnel/pc/registerFunnel',
            component: '@/pages/dashboard/pages/funnel/registerFunnelPC',
          },
          {
            path: './funnel/steam/registerFunnel',
            component: '@/pages/dashboard/pages/funnel/registerFunnelSteam',
          },
          {
            path: './funnel/epic/registerFunnel',
            component: '@/pages/dashboard/pages/funnel/registerFunnelEpic',
          },
          {
            path: './funnel/ps/registerFunnel',
            component: '@/pages/dashboard/pages/funnel/registerFunnelPS',
          },
          {
            path: './funnel/xbox/registerFunnel',
            component: '@/pages/dashboard/pages/funnel/registerFunnelXbox',
          },

          {
            path: './funnel/registerFunnelDaily',
            component: '@/pages/dashboard/pages/funnel/registerFunnelDaily',
          },

          // {
          //   path: './intlsdk/successRateAndErrorCode',
          //   component: '@/pages/dashboard/pages/commingSoon',
          // },
          {
            path: './intlsdk/successRateAndErrorCode',
            component: '@/pages/dashboard/pages/intlsdk/ErrorCode',
          },
          {
            path: './comp',
            component: '@/pages/dashboard/pages/commingSoon',
          },
          {
            path: './rfmModel',
            component: '@/pages/dashboard/pages/commingSoon',
          },

          // 自助分析在经分的承接页面
          {
            path: 'datalab/report/:dashboardid?',
            component: '@/pages/dashboard/pages/datalab/ReportAnalysis',
          },
          // 自助分析在经分的承接页面
          {
            path: './pvp/speed',
            component: '@/pages/dashboard/pages/pvp/speed',
          },
          {
            // 测试组件
            path: './test/filter',
            component: '@/pages/dashboard/pages/testPage/filter',
          },
          {
            path: './datalab/customDashboard/:dashboardId',
            component: '@/pages/dashboard/pages/datalab/CustomDashboard',
          },
          {
            path: './:module/:report/:tab?',
            component: '@/pages/dashboard/pages/configurationPage/index',
            exact: false,
          },
        ],
      },
      {
        path: './',
        component: '@/pages/dashboard/pages/index',
      },
      // datalab 自定义报表经分承接页
    ],
  },

  {
    path: '/unSubscribe',
    component: '@/pages/dashboard/pages/subscribe/unSubscribeResult',
  },
];

// 订阅实际上也是受控展示的功能，需要单独处理
export const subscribePath = [
  'subscribe/subscribeManage',
  'subscribe/subscribeRecord',
  'subscribe/subscribeSetting',
];

// 在以下两个页面切换游戏的时候，需要跳转第一个页面，因为下面的页面是需要入参的，切换游戏拿不到对应的参数
export const subscribeNotManagePath = [
  'subscribe/subscribeRecord',
  'subscribe/subscribeSetting',
];

/**
 * 不跳转默认路径 白名单
 */
export const whiteListOfRoutePath = [
  ...subscribePath,
  'overview/eventsDetails',
  'eventAnalysis/eventDetails',
  'subscribe/unSubscribe',
  // 数据格式化自测页面，需要自测的时候放开
  'dataTest/test',
  'dataTest/card',
  'Analysis/MultiAnalysis',
  'performance/overall',
  'performance/overall/android',
  'performance/overall/ios',
];
